var render = function render(){var _vm=this,_c=_vm._self._c;return _c('suspicious-activity-reviews',{attrs:{"is-loading":_vm.isLoading,"suspicious-activity-reviews":_vm.suspiciousActivityReviews,"project-options":_vm.projectOptions},on:{"load-reviews":_vm.loadReviews,"update-status":_vm.onUpdateStatus,"toggle-permission":_vm.onTogglePermission,"update-comment":_vm.onUpdateComment}})
}
var staticRenderFns = []

export { render, staticRenderFns }